import { useState } from "react";
import { FilterList } from "@mui/icons-material";
import localize from "../../common/localize";
import ModalBackground from "./ModalBackground";
import ModalFilter from "./ModalFilter";
import FilterBox from "./FilterBox";

export default function FilterManager({
  filterDataValue,
  setFilterDataValue,
  defaultFilteringValue,
  filterOptionsValue,
  filterItemNameValue,
  lateral_padding,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);

  const addFilter = (newFilter) => {
    const found = filterDataValue?.find((x) => x.Name === newFilter.Name);
    if (found) {
      const index = filterDataValue.indexOf(found);
      if (index >= 0) {
        filterDataValue.splice(index, 1);
      }
    }

    if (filterDataValue?.length > 0) {
      setFilterDataValue([...filterDataValue, newFilter]);
    } else {
      setFilterDataValue([newFilter]);
    }

    setSelectedFilter(null);
  };

  const applyFilter = () => {
    addFilter(selectedFilter);
    setShowFilterModal(false);
  };

  return (
    <div
      className={`flex items-center gap-2 mt-1 flex-wrap ${
        lateral_padding ? "lateral_padding" : ""
      }`}
    >
      {showFilterModal && (
        <ModalBackground
          isDrawerMode
          showModal={showFilterModal}
          setShowModal={setShowFilterModal}
          title={localize.filter_list}
          okButtonText={localize.accept}
          onClickToCancel={() => setShowFilterModal(false)}
          onClickToSubmit={() => {
            applyFilter();
          }}
          Component={
            <ModalFilter
              filterOptions={filterOptionsValue}
              currentFilters={filterDataValue}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              onSubmit={applyFilter}
            />
          }
        />
      )}

      <div>
        <button
          className="btn app_button app_general_button_data btn-sm"
          onClick={() => {
            setSelectedFilter(null);
            setShowFilterModal(true);
          }}
        >
          <span className="mr-2">{localize.filter_list}</span>
          <FilterList className="text-lg" />
        </button>
      </div>

      <div style={{ flex: 1 }}>
        <FilterBox
          filterItemName={filterItemNameValue}
          filterData={filterDataValue}
          setFilterData={setFilterDataValue}
          defaultFiltering={defaultFilteringValue ?? []}
          // saveFilter={
          //   filterItemNameValue?.includes('newness_filter') ||
          //   filterItemNameValue?.includes('preorder_filter')
          // }
          saveFilter
        />
      </div>
    </div>
  );
}
